import { useState } from "react";
import { HomeDirectDirectory } from "../home/HomeDirectDirectory";
import { HomeWorldControls } from "../home/HomeWorldControls";
import { EnterVillageGateway } from "../home/EnterVillageGateway";

export function HomePage() {
  const [directoryOpen, setDirectoryOpen] = useState(false);
  return (
    <section className="home-cloud-arrival" aria-labelledby="home-title">
      <div className="home-sky-interface">
        <div className="home-brand-block">
          <strong>DIGITAL GARDEN CITY</strong>
          <span>A PERSONAL WORLD OF USEFUL THINGS</span>
        </div>
        <div className="home-copy">
          <h1 id="home-title">
            Enter a living village
            <span>above the clouds.</span>
          </h1>
          <p>
            Original software, knowledge, human services and personal intelligence—
            connected through one quiet, explorable world.
          </p>
        </div>
        <div className="home-actions">
          <EnterVillageGateway onDirect={() => setDirectoryOpen(true)} />
          <button
            className="home-direct-action"
            type="button"
            aria-haspopup="dialog"
            aria-expanded={directoryOpen}
            onClick={() => setDirectoryOpen(true)}
          >
            BROWSE DIRECTLY
          </button>
        </div>
        <p className="home-ambient-line">Every light below is a destination.</p>
        <div className="home-trust-line" aria-label="Digital Garden City capabilities">
          <span>Secure Digital Delivery</span>
          <span>Personal Library</span>
          <span>Human Services</span>
          <span>Private AI</span>
        </div>
        <HomeWorldControls />
      </div>
      <HomeDirectDirectory open={directoryOpen} onClose={() => setDirectoryOpen(false)} />
    </section>
  );
}
